// Placeholders until the stats endpoint answers; same cards, in the same order, as it sends.
const card = (iconKey, title) => ({ iconKey, title, value: '0', change: 0, isPositive: true, subtitleRight: '' });

export const paymentCardData = [
  card('paywallViewed', 'Total Paywall Viewed'),
  card('purchaseStarted', 'Purchase Started'),
  card('successfulPayment', 'Successful Payments'),
  card('cancelledPayment', 'Cancelled Payments'),
  card('failedPayment', 'Failed Payments'),
];

// The stats endpoint sends |change| and isPositive = "good news"; for these two a fall is the good news.
const FALL_IS_GOOD = new Set(['cancelledPayment', 'failedPayment']);

/** Signed % change vs the previous period (+ = the count went up). */
export const signedChange = ({ iconKey, percentage, isPositive }) =>
  (isPositive !== FALL_IS_GOOD.has(iconKey) ? 1 : -1) * (Number(percentage) || 0);
